import { LOCALE_CHANGED } from '../../constants'
import { selectors as backendSelectors, actions as backendActions } from '../Backend'
import { selectors as syncSelectors } from '../Sync'

export { default as getTexts } from '../../store/localizer'

export const actions = {
    setActiveServer: serverId => backendActions.setActiveServer(serverId),
}

export const constants = {
    LOCALE_CHANGED,
}

export const selectors = {
    getServer: (state, serverId) => backendSelectors.getServer(state, serverId),
    getServers: state => backendSelectors.getServers(state),
    getTestServers: state => backendSelectors.getTestServers(state),
    getLocale: state => backendSelectors.getLocale(state),
    getDefaultServer: locale => backendSelectors.getDefaultServer(locale),
    getActiveServerId: state => backendSelectors.getActiveServerId(state),
    getServerStatus: (state, serverId) => syncSelectors.getServerStatus(state, serverId),
}



// WEBPACK FOOTER //
// ./src/features/ServerMenu/imports.js